/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : CryptoCurrency - CryptoApp 1 This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2023-present initappz.
*/
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.module').then((m) => m.AccountPageModule),
  },
  {
    path: 'aml-check',
    loadChildren: () =>
      import('./pages/Old/aml-check/aml-check.module').then(
        (m) => m.AmlCheckPageModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/Old/auth/auth.module').then((m) => m.AuthPageModule),
  },
  {
    path: 'choose-currency',
    loadChildren: () =>
      import('./pages/choose-currency/choose-currency.module').then(
        (m) => m.ChooseCurrencyPageModule
      ),
  },
  {
    path: 'deposit-btc',
    loadChildren: () =>
      import('./pages/Old/deposit-btc/deposit-btc.module').then(
        (m) => m.DepositBtcPageModule
      ),
  },
  {
    path: 'deposit-usd',
    loadChildren: () =>
      import('./pages/Old/deposit-usd/deposit-usd.module').then(
        (m) => m.DepositUsdPageModule
      ),
  },
  {
    path: 'exchange',
    loadChildren: () =>
      import('./pages/Old/exchange/exchange.module').then(
        (m) => m.ExchangePageModule
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'invite-friends',
    loadChildren: () =>
      import('./pages/invite-friends/invite-friends.module').then(
        (m) => m.InviteFriendsPageModule
      ),
  },
  {
    path: 'leaderboard',
    loadChildren: () =>
      import('./pages/leaderboard/leaderboard.module').then(
        (m) => m.LeaderboardPageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/Old/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'market',
    loadChildren: () =>
      import('./pages/Old/market/market.module').then(
        (m) => m.MarketPageModule
      ),
  },
  {
    path: 'nft',
    loadChildren: () =>
      import('./pages/nft/nft.module').then((m) => m.NftPageModule),
  },
  {
    path: 'nft-filter',
    loadChildren: () =>
      import('./pages/Old/nft-filter/nft-filter.module').then(
        (m) => m.NftFilterPageModule
      ),
  },
  {
    path: 'nft-profile',
    loadChildren: () =>
      import('./pages/Old/nft-profile/nft-profile.module').then(
        (m) => m.NftProfilePageModule
      ),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./pages/notifications/notifications.module').then(
        (m) => m.NotificationsPageModule
      ),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./pages/Old/payment/payment.module').then(
        (m) => m.PaymentPageModule
      ),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/Old/register/register.module').then(
        (m) => m.RegisterPageModule
      ),
  },
  {
    path: 'staking',
    loadChildren: () =>
      import('./pages/Old/staking/staking.module').then(
        (m) => m.StakingPageModule
      ),
  },
  {
    path: 'stock-info',
    loadChildren: () =>
      import('./pages/Old/stock-info/stock-info.module').then(
        (m) => m.StockInfoPageModule
      ),
  },
  {
    path: 'support-modal',
    loadChildren: () =>
      import('./pages/support-modal/support-modal.module').then(
        (m) => m.SupportModalPageModule
      ),
  },
  {
    path: 'stock-marketplace-help-modal',
    loadChildren: () =>
      import(
        './pages/stock-marketplace-help-modal/stock-marketplace-help-modal.module'
      ).then((m) => m.StockMarketplaceHelpModalPageModule),
  },
  {
    path: 'agent-dashboard-help-modal',
    loadChildren: () =>
      import(
        './pages/agent-dashboard-help-modal/agent-dashboard-help-modal.module'
      ).then((m) => m.AgentDashboardHelpModalPageModule),
  },
  {
    path: 'top-nft',
    loadChildren: () =>
      import('./pages/Old/top-nft/top-nft.module').then(
        (m) => m.TopNftPageModule
      ),
  },
  {
    path: 'top-nftcollection',
    loadChildren: () =>
      import('./pages/Old/top-nftcollection/top-nftcollection.module').then(
        (m) => m.TopNftcollectionPageModule
      ),
  },
  {
    path: 'trade',
    loadChildren: () =>
      import('./pages/Old/trade/trade.module').then((m) => m.TradePageModule),
  },
  {
    path: 'verification',
    loadChildren: () =>
      import('./pages/verification/verification.module').then(
        (m) => m.VerificationPageModule
      ),
  },
  {
    path: 'wallet',
    loadChildren: () =>
      import('./pages/Old/wallet/wallet.module').then(
        (m) => m.WalletPageModule
      ),
  },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'disclaimer',
    loadChildren: () =>
      import('./pages/disclaimer/disclaimer.module').then((m) => m.DisclaimerPageModule),
  },
  {
    path: 'solana-callback',
    loadChildren: () =>
      import('./pages/solana-callback/solana-callback.module').then((m) => m.SolanaCallbackPageModule),
  },
  {
    path: 'withdraw',
    loadChildren: () =>
      import('./pages/Old/withdraw/withdraw.module').then(
        (m) => m.WithdrawPageModule
      ),
  },
  {
    path: 'projects',
    loadChildren: () =>
      import('./pages/projects/projects.module').then(
        (m) => m.ProjectsPageModule
      ),
  },
  {
    path: 'project',
    loadChildren: () =>
      import('./pages/project/project.module').then((m) => m.ProjectPageModule),
  },
  {
    path: 'presales',
    loadChildren: () =>
      import('./pages/presales/presales.module').then(
        (m) => m.PresalesPageModule
      ),
  },
  {
    path: 'presale',
    loadChildren: () =>
      import('./pages/presale/presale.module').then((m) => m.PresalePageModule),
  },
  {
    path: 'signals',
    loadChildren: () =>
      import('./pages/signals/signals.module').then((m) => m.SignalsPageModule),
  },
  {
    path: 'signal',
    loadChildren: () =>
      import('./pages/signal/signal.module').then((m) => m.SignalPageModule),
  },
  {
    path: 'earnings',
    loadChildren: () =>
      import('./pages/earnings/earnings.module').then(
        (m) => m.EarningsPageModule
      ),
  },
  {
    path: 'airdrops',
    loadChildren: () =>
      import('./pages/airdrops/airdrops.module').then(
        (m) => m.AirdropsPageModule
      ),
  },
  {
    path: 'airdrop',
    loadChildren: () =>
      import('./pages/airdrop/airdrop.module').then((m) => m.AirdropPageModule),
  },
  {
    path: 'short-term',
    loadChildren: () =>
      import('./pages/short-term/short-term.module').then(
        (m) => m.ShortTermPageModule
      ),
  },
  {
    path: 'short-term-details',
    loadChildren: () =>
      import('./pages/short-term-details/short-term-details.module').then(
        (m) => m.ShortTermDetailsPageModule
      ),
  },
  {
    path: 'next-listing',
    loadChildren: () =>
      import('./pages/next-listing/next-listing.module').then(
        (m) => m.NextListingPageModule
      ),
  },
  {
    path: 'enable-key-slider',
    loadChildren: () =>
      import('./pages/enable-key-slider/enable-key-slider.module').then(
        (m) => m.EnableKeySliderPageModule
      ),
  },
  {
    path: 'activation-confirmation',
    loadChildren: () =>
      import(
        './pages/activation-confirmation/activation-confirmation.module'
      ).then((m) => m.ActivationConfirmationPageModule),
  },
  {
    path: 'tools',
    loadChildren: () =>
      import('./pages/tools/tools.module').then((m) => m.ToolsPageModule),
  },
  {
    path: 'friends',
    loadChildren: () =>
      import('./pages/friends/friends.module').then((m) => m.FriendsPageModule),
  },
  {
    path: 'address',
    loadChildren: () =>
      import('./pages/address/address.module').then((m) => m.AddressPageModule),
  },
  {
    path: 'choose-wallet',
    loadChildren: () =>
      import('./pages/choose-wallet/choose-wallet.module').then(
        (m) => m.ChooseWalletPageModule
      ),
  },
  {
    path: 'filter',
    loadChildren: () =>
      import('./pages/filter/filter.module').then((m) => m.FilterPageModule),
  },
  {
    path: 'stock-list',
    loadChildren: () =>
      import('./pages/stock-list/stock-list.module').then(
        (m) => m.StockListPageModule
      ),
  },
  {
    path: 'stock-details',
    loadChildren: () =>
      import('./pages/stock-details/stock-details.module').then(
        (m) => m.StockDetailsPageModule
      ),
  },
  {
    path: 'indice-list',
    loadChildren: () =>
      import('./pages/indice-list/indice-list.module').then(
        (m) => m.IndiceListPageModule
      ),
  },
  {
    path: 'indice-details',
    loadChildren: () =>
      import('./pages/indice-details/indice-details.module').then(
        (m) => m.IndiceDetailsPageModule
      ),
  },
  {
    path: 'bond-list',
    loadChildren: () =>
      import('./pages/bond-list/bond-list.module').then(
        (m) => m.BondListPageModule
      ),
  },
  {
    path: 'bond-details',
    loadChildren: () =>
      import('./pages/bond-details/bond-details.module').then(
        (m) => m.BondDetailsPageModule
      ),
  },
  {
    path: 'commodity-list',
    loadChildren: () =>
      import('./pages/commodity-list/commodity-list.module').then(
        (m) => m.CommodityListPageModule
      ),
  },
  {
    path: 'commodity-details',
    loadChildren: () =>
      import('./pages/commodity-details/commodity-details.module').then(
        (m) => m.CommodityDetailsPageModule
      ),
  },
  {
    path: 'coming-soon',
    loadChildren: () =>
      import('./pages/coming-soon/coming-soon.module').then(
        (m) => m.ComingSoonPageModule
      ),
  },
  {
    path: 'dao-proposal',
    loadChildren: () =>
      import('./pages/dao-proposal/dao-proposal.module').then(
        (m) => m.DaoProposalPageModule
      ),
  },
  {
    path: 'dao-wallet-tokens',
    loadChildren: () =>
      import('./pages/dao-wallet-tokens/dao-wallet-tokens.module').then(
        (m) => m.DaoWalletTokensPageModule
      ),
  },
  {
    path: 'points-leaderboard',
    loadChildren: () =>
      import('./pages/points-leaderboard/points-leaderboard.module').then(
        (m) => m.PointsLeaderboardPageModule
      ),
  },
  {
    path: 'points-claim',
    loadChildren: () =>
      import('./pages/points-claim/points-claim.module').then(
        (m) => m.PointsClaimPageModule
      ),
  },
  {
    path: 'earn',
    loadChildren: () =>
      import('./pages/earn/earn.module').then((m) => m.EarnPageModule),
  },
  {
    path: 'earn-portfolio',
    loadChildren: () =>
      import('./pages/earn-portfolio/earn-portfolio.module').then(
        (m) => m.EarnPortfolioPageModule
      ),
  },
  {
    path: 'learn-course',
    loadChildren: () =>
      import('./pages/learn-course/learn-course.module').then(
        (m) => m.LearnCoursePageModule
      ),
  },
  {
    path: 'learn-teacher',
    loadChildren: () =>
      import('./pages/learn-teacher/learn-teacher.module').then(
        (m) => m.LearnTeacherPageModule
      ),
  },
  {
    path: 'learn-watch',
    loadChildren: () =>
      import('./pages/learn-watch/learn-watch.module').then(
        (m) => m.LearnWatchPageModule
      ),
  },
  {
    path: 'learn-dashboard',
    loadChildren: () =>
      import('./pages/learn-dashboard/learn-dashboard.module').then(
        (m) => m.LearnDashboardPageModule
      ),
  },
  {
    path: 'learn-create',
    loadChildren: () =>
      import('./pages/learn-create/learn-create.module').then(
        (m) => m.LearnCreatePageModule
      ),
  },
  {
    path: 'learn-admin',
    loadChildren: () =>
      import('./pages/learn-admin/learn-admin.module').then(
        (m) => m.LearnAdminPageModule
      ),
  },
  {
    path: 'learn-help',
    loadChildren: () =>
      import('./pages/learn-help/learn-help.module').then(
        (m) => m.LearnHelpPageModule
      ),
  },
  {
    path: 'p2p-help',
    loadChildren: () =>
      import('./pages/p2p-help/p2p-help.module').then(
        (m) => m.P2pHelpPageModule
      ),
  },
  {
    path: 'dao-help',
    loadChildren: () =>
      import('./pages/dao-help/dao-help.module').then(
        (m) => m.DaoHelpPageModule
      ),
  },
  {
    path: 'earn-help',
    loadChildren: () =>
      import('./pages/earn-help/earn-help.module').then(
        (m) => m.EarnHelpPageModule
      ),
  },
  {
    path: 'help',
    loadChildren: () =>
      import('./pages/help/help.module').then((m) => m.HelpPageModule),
  },
  {
    path: 'short-term-performance',
    loadChildren: () =>
      import(
        './pages/short-term-performance/short-term-performance.module'
      ).then((m) => m.ShortTermPerformancePageModule),
  },
  {
    path: 'buy-iris',
    loadChildren: () =>
      import('./pages/buy-iris/buy-iris.module').then(
        (m) => m.BuyIrisPageModule
      ),
  },
  {
    path: 'token-swap',
    loadChildren: () =>
      import('./pages/token-swap/token-swap.module').then(
        (m) => m.TokenSwapPageModule
      ),
  },
  {
    path: 'solana-token-swap',
    loadChildren: () =>
      import('./pages/solana-token-swap/solana-token-swap.module').then(
        (m) => m.SolanaTokenSwapPageModule
      ),
  },
  {
    path: 'my-boosters',
    loadChildren: () =>
      import('./pages/my-boosters/my-boosters.module').then(
        (m) => m.MyBoostersPageModule
      ),
  },
  {
    path: 'leaderboard-help',
    loadChildren: () =>
      import('./pages/leaderboard-help/leaderboard-help.module').then(
        (m) => m.LeaderboardHelpPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
